import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import {Link} from "react-router-dom"; 
import $ from 'jquery';

export default class UserAdd extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">    
        <Menu></Menu>    
          <div className="content-right-wrapper">
            <div className="container">
              <form className='form-wrapper'>
                <div className='form-head'>Userlist</div>
                <div className="form-group">
                  <label for="exampleFormControlInput1">Email address</label>
                  <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com" />
                </div>
                <div className="form-group">
                  <label for="exampleFormControlSelect1">Example select</label>
                  <select className="form-control" id="exampleFormControlSelect1">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
                <div className="form-group">
                  <label for="exampleFormControlSelect2">Example multiple select</label>
                  <select multiple className="form-control" id="exampleFormControlSelect2">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
                <div className="form-group">
                  <label for="exampleFormControlTextarea1">Example textarea</label>
                  <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                </div>
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                  <label className="form-check-label" for="exampleCheck1">Check me out</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1"  />
                  <label className="form-check-label" for="exampleRadios1">
                    Default radio
                  </label>
                </div>
                <div className="form-group mt-4">
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
            
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/admin/user-add.jsx